import { render, staticRenderFns } from "./external-login.vue?vue&type=template&id=647878f0"
import script from "./external-login.vue?vue&type=script&lang=js"
export * from "./external-login.vue?vue&type=script&lang=js"
import style0 from "./external-login.vue?vue&type=style&index=0&id=647878f0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports